export function LogoMark({ className = "w-9 h-9 sm:w-10 sm:h-10" }) {
  return (
    <span
      className={`${className} rounded-xl bg-[#0F1012] grid place-items-center shadow-md shadow-black/15 transition-transform group-hover:rotate-3 overflow-hidden flex-shrink-0`}
    >
      <img
        src="/logo-mark.png"
        alt=""
        aria-hidden="true"
        className="w-4/5 h-4/5 object-contain"
      />
    </span>
  );
}

export default function Logo() {
  return (
    <span className="flex items-center gap-2 sm:gap-2.5">
      <LogoMark />
      <span className="leading-none">
        <span className="block font-heading font-medium text-base sm:text-xl tracking-[0.12em] sm:tracking-[0.14em] text-[#1C1D21]">
          REFLECTUM
        </span>
        <span className="block font-display text-[8px] sm:text-[9px] font-bold tracking-[0.3em] sm:tracking-[0.36em] text-[#C5A880] mt-0.5 sm:mt-1">
          PELLICULE
        </span>
      </span>
    </span>
  );
}
